import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import azmLogo from '../Images/logo-azm-2.png';

export default function Footer() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);
  return (
    <>
  {/* <!-- Footer Start --> */}
    <div className="container-fluid bg-dark text-light py-5 wow fadeInUp" data-wow-delay="0.3s" style={{marginTop: "-75px"}}>
        <div className="container pt-5">
            <div className="row g-5 pt-4">
                <div className="col-lg-3 col-md-6">
                <img className="img-fluid logo" src={azmLogo} alt="Azm Rehab Centre logo" />
                <h3 className="text-white mb-4">WE CARE<br/> ALLAH CURES</h3>
                </div>
                <div className="col-lg-2 col-md-6">
                    <h3 className="text-white mb-4">Popular Links</h3>
                    <div className="d-flex flex-column justify-content-start">
                        <Link className="text-light mb-2" to="/"><i className="bi bi-arrow-right text-primary me-2"></i>Home</Link>
                        <Link className="text-light mb-2" to="/service"><i className="bi bi-arrow-right text-primary me-2"></i>Our Services</Link>
                        <Link className="text-light mb-2" to="/staff-team"><i className="bi bi-arrow-right text-primary me-2"></i>Staff Team</Link>
                        <Link className="text-light" to="/contact-us"><i className="bi bi-arrow-right text-primary me-2"></i>Contact Us</Link>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <h3 className="text-white mb-4 mt-5">Get In Touch</h3>
                    <p className="mb-2"><i className="bi bi-geo-alt text-primary me-2"></i>329/A PUNJAB COLLEGE ROAD, Satellite Town, Sargodha, Punjab 40100</p>
                    <p className="mb-2"><i className="bi bi-envelope-open text-primary me-2"></i><a className="text-light" href="mailto:zubairmukhtar14@gmail.com">zubairmukhtar14@gmail.com</a></p>
                    <p className="mb-0"><i className="bi bi-telephone text-primary me-2"></i><a className="text-light" href="tel:+923009605574">03009605574</a></p>
                </div>
                <div className="col-lg-3 col-md-6 d-flex justify-content-center mb-4 mb-md-0">
    <div className="text-center">
        <h3 className="text-white mb-4 mt-5">Stay Connected for Recovery Updates</h3>
        <p className="text-white mb-3">Follow us for tips and support in your journey to recovery. (ہمارے ساتھ جڑے رہیں تاکہ نشے سے چھٹکارے کے مشورے اور مدد حاصل کریں)</p>
    </div>
</div>


            </div>
        </div>
    </div>
   <div className="container-fluid text-light py-4" style={{background: "#051225"}}>
      <div className="container">
        <div className="row g-0">
          <div className="col-md-6 text-center text-md-start">
            <p className="mb-md-0">
              &copy; <Link className="text-white border-bottom" to="/">
                AZM Rehab Centre
              </Link>. All Rights Reserved. {currentYear}
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p className="mb-0">
              Powered by <span className="text-white">NexusGen Software</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Footer End --> */}



    </>
  );
}
